import React from 'react';
import { RotationSystem } from '../mount/RotationSystem';

/** "The Always Ready Lighting System" — sells backup sets through the interactive rotation demo. */
export function AlwaysReady() {
  return <section aria-labelledby="always-ready-title" className="border-t mf-hairline bg-navy" data-id="element-190" data-mp="1u18qgfd8vc4c">
      <div className="mx-auto max-w-site px-5 py-10 md:px-8 md:py-14" data-id="element-191" data-mp="1q0x9bck3btxm">
        <p className="font-display text-lg uppercase tracking-[0.14em] text-titanium" data-id="element-192" data-mp="2mqobzz2jcnei">The Always Ready Lighting System</p>
        <h2 id="always-ready-title" className="mt-3 max-w-4xl font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-193" data-mp="2hr324tltuun0">
          One set in use. <span className="text-ice" data-id="element-194" data-mp="2cz1pv7ont3wz">One set ready to go.</span>
        </h2>
        <div className="mt-6 max-w-2xl space-y-4 text-lg text-titanium" data-id="element-195" data-mp="28yhx0gb4cmgn">
          <p data-id="element-196" data-mp="35hfhuqnbdvo5">Why buy only enough rechargeable lights for your installation when you can keep a fully charged backup set ready?</p>
          <p data-id="element-197" data-mp="30ow51vwgb4ke">
            Keep one set installed and another set charged. When your installed lights need charging, exchange them with the
            backup set, then recharge the removed lights. Your mounting positions stay exactly where they belong — a simple
            weekly routine for evenings by the pool.
          </p>
        </div>
        <p className="mt-6 font-display text-2xl font-semibold uppercase tracking-[0.08em] text-white" data-id="element-198" data-mp="3ap9si08gmfz5">Swap. Recharge. Repeat.</p>
        <div className="mt-8" data-id="element-199" data-mp="2wp8q2gcjr0hk">
          <RotationSystem showOffer={false} data-id="element-200" data-mp="2wo74hhxwmvll" />
        </div>
      </div>
    </section>;
}